//是否显示商家交易管理的tip 1隐藏 2显示
export default ({
    state: {
        tips: 1
    },
    mutations: {
        setNow(state, type) {
                state.tips = type
        }
    },
    actions: {
        setTips(context, type) {
            context.commit('setNow', type)
        }
    }
})